module.exports = __webpack_public_path__ + "static/img/AdvancedTorsoDesign2.81391a38.jpg";